import { IChannelLabel, transformChannelLabel } from '~/src/dash/api/console-api';
import { generateTokenParams, IHttpResponse, restGet } from '~/src/dash/api/rest';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IUserState } from '~/src/dash/reducers/user-reducers';
import { getApiDomain } from '~/src/dash/resellers/utils/importResellerConfig';
import { IMenuList } from '~/src/dash/types/menuList';
import { obfuscateChannelLabels } from '~/src/dash/utils/obfuscate';

export async function getChannelLabelsAsIMenuList(
  session: ISessionState,
  user: IUserState,
): Promise<Record<string, IMenuList>> {
  const reqUrl = `${getApiDomain()}/v1/settings/channel_label?${generateTokenParams(
    session.publisher.ID,
  )}`;
  return await restGet<any>(reqUrl, {})
    .then((val: IHttpResponse<any>) => {
      const channelLabels = val.parsedBody?.map(transformChannelLabel);
      return {
        channelLabels: generateChannelLabelMenuList(channelLabels, user.user.Username),
      };
    })
    .catch((e) => {
      console.error(e);
      return {
        channelLabels: {},
      };
    });
}

export const generateChannelLabelMenuList = (
  channelLabels: IChannelLabel[],
  username: string,
): IMenuList => {
  const menuList: IMenuList = {};

  channelLabels.forEach((channelLabel: IChannelLabel) => {
    menuList[channelLabel.ID] = {
      ID: channelLabel.ID.toString(),
      selected: false,
      title: obfuscateChannelLabels(
        channelLabel,
        username,
        `[${channelLabel.ID}] ${channelLabel.Name}`,
      ),
    };
  });

  return menuList;
};
